import { useState } from "react";
import { FilterButton } from "../atoms/FilterButton";
import { PageHeader } from "../molecules/PageHeader";
import { StatsGrid } from "../organisms/StatsGrid";
import { DataTable } from "../organisms/DataTable";
import { More } from "iconsax-react";

import {
  MODERATION_STATS,
  REPORT_TABLE_HEADERS,
  MOCK_MODERATION,
  type ModerationType,
} from "@/data";

const ReportTableRow = ({ report }: { report: ModerationType }) => (
  <tr className="border-b border-dark-30 hover:bg-dark-30 transition-colors">
    <td className="px-6 py-4 text-dark-text font-medium">
      {report.contentType}
    </td>
    <td className="px-6 py-4 text-dark-text">{report.preview}</td>
    <td className="px-6 py-4 text-dark-text">{report.reportedBy}</td>
    <td className="px-6 py-4 text-dark-text">{report.reason}</td>
    <td className="px-6 py-4 text-dark-text">{report.reportCount}</td>
    <td className="px-6 py-4 text-dark-text">{report.dateReported}</td>
    <td className="px-6 py-4">
      <span className="inline-flex px-2 py-1 rounded text-sm text-dark-text">
        {report.status}
      </span>
    </td>
    <td className="px-6 py-4">
      <button className="text-dark-100 hover:text-dark-text transition-colors p-1">
        <More className="w-6 h-6" color="#EEEEEE" />
      </button>
    </td>
  </tr>
);

const Moderation = () => {
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <div className="max-w-7xl mx-auto space-y-10">
      <PageHeader title="Content Moderation" />

      <StatsGrid stats={MODERATION_STATS} columns={2} />

      <DataTable
        title="Report Table"
        headers={REPORT_TABLE_HEADERS}
        data={MOCK_MODERATION}
        renderRow={(report) => (
          <ReportTableRow key={report.id} report={report} />
        )}
        filters={
          <>
            <FilterButton label="Content Type" />
            <FilterButton label="Status" />
            <FilterButton label="Date Range" />
          </>
        }
        currentPage={currentPage}
        onPageChange={setCurrentPage}
      />
    </div>
  );
};

export default Moderation;
